"use client";

import { c as _c } from "react/compiler-runtime";
import { useEnsResolution } from "@/hooks/useEnsResolution";
import { useEffect, useEffectEvent } from "react";
import { Form } from "react-bootstrap";
interface EnsAddressInputProps {
  readonly value?: string;
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly autoFocus?: boolean;
  readonly className?: string | undefined;
  readonly chainId?: number;
  readonly onAddressChange: (address: string) => void;
  readonly onValueChange?: (value: string) => void;
  readonly onLoadingChange?: (isLoading: boolean) => void;
  readonly onError?: (hasError: boolean) => void;
}
export default function EnsAddressInput(t0) {
  const $ = _c(44);
  const {
    value: t1,
    placeholder: t2,
    disabled: t3,
    autoFocus: t4,
    className,
    chainId: t5,
    onAddressChange,
    onValueChange,
    onLoadingChange,
    onError
  } = t0;
  const value = t1 === undefined ? "" : t1;
  const placeholder = t2 === undefined ? "0x... or ENS" : t2;
  const disabled = t3 === undefined ? false : t3;
  const autoFocus = t4 === undefined ? false : t4;
  const chainId = t5 === undefined ? 1 : t5;
  let t6;
  if ($[0] !== chainId || $[1] !== value) {
    t6 = {
      initialValue: value,
      chainId
    };
    $[0] = chainId;
    $[1] = value;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const {
    inputValue,
    address,
    handleInputChange,
    ensNameQuery,
    ensAddressQuery
  } = useEnsResolution(t6);
  let t7;
  if ($[3] !== onAddressChange) {
    t7 = addr => {
      onAddressChange(addr);
    };
    $[3] = onAddressChange;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const onAddressChangeEvent = useEffectEvent(t7);
  let t8;
  if ($[5] !== onValueChange) {
    t8 = val => {
      onValueChange?.(val);
    };
    $[5] = onValueChange;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const onValueChangeEvent = useEffectEvent(t8);
  let t9;
  if ($[7] !== onLoadingChange) {
    t9 = isLoading => {
      onLoadingChange?.(isLoading);
    };
    $[7] = onLoadingChange;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const onLoadingChangeEvent = useEffectEvent(t9);
  let t10;
  if ($[9] !== onError) {
    t10 = hasError => {
      onError?.(hasError);
    };
    $[9] = onError;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const onErrorEvent = useEffectEvent(t10);
  let t11;
  if ($[11] !== address || $[12] !== onAddressChangeEvent) {
    t11 = () => {
      onAddressChangeEvent(address);
    };
    $[11] = address;
    $[12] = onAddressChangeEvent;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== address) {
    t12 = [address];
    $[14] = address;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  useEffect(t11, t12);
  let t13;
  if ($[16] !== inputValue || $[17] !== onValueChangeEvent) {
    t13 = () => {
      onValueChangeEvent(inputValue);
    };
    $[16] = inputValue;
    $[17] = onValueChangeEvent;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== inputValue) {
    t14 = [inputValue];
    $[19] = inputValue;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  useEffect(t13, t14);
  let t15;
  if ($[21] !== ensAddressQuery.isLoading || $[22] !== ensNameQuery.isLoading || $[23] !== onLoadingChangeEvent) {
    t15 = () => {
      const isLoading_0 = ensNameQuery.isLoading || ensAddressQuery.isLoading;
      onLoadingChangeEvent(isLoading_0);
    };
    $[21] = ensAddressQuery.isLoading;
    $[22] = ensNameQuery.isLoading;
    $[23] = onLoadingChangeEvent;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== ensAddressQuery.isLoading || $[26] !== ensNameQuery.isLoading) {
    t16 = [ensNameQuery.isLoading, ensAddressQuery.isLoading];
    $[25] = ensAddressQuery.isLoading;
    $[26] = ensNameQuery.isLoading;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  useEffect(t15, t16);
  let t17;
  if ($[28] !== ensAddressQuery.isError || $[29] !== inputValue || $[30] !== onErrorEvent) {
    t17 = () => {
      const isEnsInput = inputValue?.toLowerCase().endsWith(".eth");
      if (isEnsInput && ensAddressQuery.isError) {
        onErrorEvent(true);
      } else {
        onErrorEvent(false);
      }
    };
    $[28] = ensAddressQuery.isError;
    $[29] = inputValue;
    $[30] = onErrorEvent;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== ensAddressQuery.isError || $[33] !== inputValue) {
    t18 = [inputValue, ensAddressQuery.isError];
    $[32] = ensAddressQuery.isError;
    $[33] = inputValue;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  useEffect(t17, t18);
  let t19;
  if ($[35] !== handleInputChange) {
    t19 = e => handleInputChange(e.target.value);
    $[35] = handleInputChange;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== autoFocus || $[38] !== className || $[39] !== disabled || $[40] !== inputValue || $[41] !== placeholder || $[42] !== t19) {
    t20 = <Form.Control disabled={disabled} autoFocus={autoFocus} placeholder={placeholder} className={className} type="text" value={inputValue} onChange={t19} />;
    $[37] = autoFocus;
    $[38] = className;
    $[39] = disabled;
    $[40] = inputValue;
    $[41] = placeholder;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
}